import type { ReactNode } from 'react'
import { isStagingHost } from '@region13/shared-types'
import { StagingMarker } from '@region13/ui'

/** Branded top bar: AYSO logo + REGION 13 / COACH wordmark over the two-tone
 *  strip. Used by the signed-out Login frame (Shell) and, on mobile only, by
 *  the signed-in AppShell (desktop uses the Sidebar instead). The `className`
 *  lets a caller gate visibility (e.g. `md:hidden`). On a staging host it
 *  shows the same Staging marker as the desktop sidebar. */
export function Masthead({
  headerRight,
  className = '',
  hostname,
}: {
  headerRight?: ReactNode
  className?: string
  /** Tests only; defaults to window.location.hostname. */
  hostname?: string
}) {
  const staging = isStagingHost(hostname ?? window.location.hostname)
  return (
    <div className={className}>
      <header className="masthead justify-between bg-sidebar">
        <div className="flex items-center gap-3 min-w-0">
          <img className="masthead-logo" src="/logo.svg" width={40} height={40} alt="AYSO Region 13" />
          <div className="wordmark">
            <span className="wordmark-title">REGION 13</span>
            <span className="wordmark-sub">COACH</span>
          </div>
          {staging ? <StagingMarker /> : null}
        </div>
        {headerRight}
      </header>
      <div className="strip" />
      <div className="strip-thin" />
    </div>
  )
}
